import { EventEmitter } from "events"

const bus: EventEmitter = global.__bus__ ? global.__bus__ : new EventEmitter()
global.__bus__ = bus

export const TRACKED_EVENTS = [
  "gift_created",
  "gift_claimed",
  "gift_link_copied",
  "gift_link_viewed",
  "gift_link_refunded",
  "deposit_initiated",
  "deposit_success",
  "deposit_failed",
  "otc_deal_initiated",
  "swap_initiated",
  "swap_confirmed",
  "swap_failed",
  "swap_cancelled",
  "otc_confirmed",
  "withdrawal_initiated",
  "withdrawal_confirmed",
  "withdrawal_failed",
  "contact_created",
  "contact_updated",
  "contact_deleted",
  "contact_transfer_clicked",
  "contact_selected_as_recipient",
  "contact_search_performed",
  "contact_modal_opened",
  "contact_create_from_transfer",
  "swap_quote_requested",
  "swap_quote_rejected",
  "swap_abandoned",
] as const

export default global.__bus__
